import { useState, useEffect, useCallback } from 'react';
import API from 'api/api';
import { useFirebaseAuth } from 'domains/auth/hooks/useFirebaseAuth';

export default function useFetchTrucks() {
  const { uid } = useFirebaseAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTrucks = useCallback(async () => {
    if (!uid) return;
    setLoading(true);
    try {
      const res = await API.get(`/users/${uid}/trucks`);
      setData(res.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [uid]);

  useEffect(() => {
    if (uid) {
      fetchTrucks();
    }
  }, [uid, fetchTrucks]);

  return { data, loading, error, fetchTrucks };
}
